module.exports = __webpack_public_path__ + "img/navigation_action.efb20889.png";